module.exports = __webpack_public_path__ + "static/media/iri.4b62a81a.png";